<template>
  <div class="page page-testimonials">
    <div class="container">

      <h1 class="page-title text-center">
        What people are saying?
      </h1>

      <div class="testimonials-list">
        <TestimonialItem
          v-for="(testimonial, index) in testimonials"
          :testimonial="testimonial"
          :key="index"
        />
      </div>

    </div>
  </div>
</template>

<script>
import TestimonialItem from '@/components/TestimonialItem'

export default {
  components: {
    TestimonialItem
  },

  data () {
    return {
      testimonials: [
        {
          user: 'Greg Williams',
          date: 'Client since 2017',
          img: 'greg-williams.jpg',
          quote:
            'My experience training with Saska has been resoundingly positive, transformative and unique. Saska truly cares about the people she works with and dedicates herself to understanding their specific needs rather than a “one-size-fits-all” approach that I’ve experienced with trainers in the past. She personally invests in her clients and pushes us to succeed and always do our best. But, she also realizes that life can be challenging and there will be times when work or injuries get in the way but the key to success is to push through and never give up. Saska truly inspires me to be better person both in and out of the gym and she gives me the confidence to believe in myself and realize that I have what it takes to get the results I want.'
        },
        {
          user: 'Eric Thomsen',
          date: 'Client since 2018',
          img: 'eric-thomsen.jpg',
          quote:
            "I have always been intimidated by the thought of bootcamp workouts. I'm not an athlete nor particularly fit. I was doubtful Saska's bootcamp would be a place for me. Instead I found her approach to be encouraging, positive and uplifting. She is not a bully. She's a highly motivational trainer who makes every effort to ensure you're training safely and avoiding injury. Her personal commitment to your success is inspiring. Saska helped me find strength and stamina I didn't know I had in me. My weekly workouts at the beach are challenging. I push myself to my limit and I always end with a great feeling of accomplishment and confidence. I never hesitate to recommend Saska's program to my friends of all fitness levels."
        },
        {
          user: 'Courtney Silbiger',
          date: 'Client since 2016',
          img: 'courtney-silbiger.jpg',
          quote:
            "Saska is a wonderful trainer, mentor and coach. Her training sessions are empowering and she's always positive and inspirational. She’s my biggest fan when I’m training with her and it feels really good to be encouraged and rewarded after each exercise. Always with an infectious smile on her face, I leave with more energy and excited for more! The classes are fun, well-rounded, different each time and she plays great music!!"
        },
        {
          user: 'Chad Harrington',
          date: 'Client since 2017',
          img: 'chad-harrington.jpg',
          quote:
            "Saska is my favorite trainer hands down! I know when I'm working out with Saska I can expect an intense workout session. She's great at ramping up the intensity of my workouts but not pushing me over the edge. But best of all she keeps everything FUN!"
        }
      ]
    }
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import "../assets/scss/beach-built/imports";

.page-testimonials {

  @include media-breakpoint-up(lg) {
    .page-title {
      margin-bottom: 0
    }
  }

}

</style>
